import { gql } from '@apollo/client';
const REMOVE_TENANT_TEMPLATE = gql `
  mutation RemoveTenantTemplate($templateId: ID!) {
    removeModelSpecificationTemplate(templateId: $templateId) {
      removed
    }
  }
`;
export default REMOVE_TENANT_TEMPLATE;
